export default function SvgArrowDown({ stroke = '#ECECEB' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          x="20"
          width="20"
          height="20"
          transform="rotate(90 20 0)"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9360_1449)">
        <path
          d="M10 2.5L10 17.5"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1667 13.3335L9.99999 17.5002L5.83332 13.3335"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
